// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2012%2012%22%3E%3Ctitle%3Edown-arrow%3C%2Ftitle%3E%3Cg%20fill%3D%22%23000000%22%3E%3Cpath%20d%3D%22M10.293%2C3.293%2C6%2C7.586%2C1.707%2C3.293A1%2C1%2C0%2C0%2C0%2C.293%2C4.707l5%2C5a1%2C1%2C0%2C0%2C0%2C1.414%2C0l5-5a1%2C1%2C0%2C1%2C0-1.414-1.414Z%22%20fill%3D%22%23000000%22%3E%3C%2Fpath%3E%3C%2Fg%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
* ==========================================================
*     GENERAL STYLING
* ==========================================================
*/
*/ body {
  position: relative;
}

section {
  padding: 0 0.6rem;
}

/* a {
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  display: inline-block;
} */

.topHeader {
  background: #fff;
}

.dashtext-1 {
  color: #864dd9 !important;
}

.dashtext-2 {
  color: #cf53f9 !important;
}

.dashtext-3 {
  color: #e95f71 !important;
}

.dashtext-4 {
  color: #7127ac !important;
}

.dashbg-1 {
  background: #864dd9;
}

.dashbg-2 {
  background: #cf53f9;
}

.dashbg-3 {
  background: #e95f71;
}

.dashbg-4 {
  background: #7127ac;
}

.text-bold {
  font-weight: 700;
}

.text-small {
  font-size: 0.8rem;
}

.text-gray-light {
  color: #dee2e6;
}

.text-gray {
  color: #8a8d93;
}

.text-gray-dark {
  color: #6a6c70;
}

.text-black {
  color: #000;
}

.text-uppercase {
  letter-spacing: 0.1em;
}

.lh-2 {
  line-height: 2;
}

.list-group-item {
  border-right: 0;
  border-left: 0;
}

.list-group-item:first-child,
.list-group-item:last-child {
  border-radius: 0;
}

.overflow-hidden {
  overflow: hidden;
}

.tile-link {
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 30;
}

p {
  line-height: 1.7;
}

button {
  cursor: pointer;
  background-color: transparent;
  border: none;
}

i,
span,
strong {
  display: inline-block;
}

input {
  outline: none;
}

pre {
  color: #8a8d93;
}

.dropdown-divider {
  border-top-color: #6a6c70;
}

.no-padding {
  padding: 0 !important;
}

.no-padding-top {
  padding-top: 0 !important;
}

.no-padding-bottom {
  padding-bottom: 0 !important;
}

.no-margin {
  margin: 0 !important;
}

.no-margin-top {
  margin-top: 0 !important;
}

.no-margin-bottom {
  margin-bottom: 0 !important;
}

.padding-top-sm {
  padding-top: 30px !important;
}

.padding-bottom-sm {
  padding-bottom: 30px !important;
}

.margin-top-sm {
  margin-top: 30px !important;
}

.margin-bottom-sm {
  margin-bottom: 30px !important;
}

.breadcrumb {
  background: none;
  padding: 20px 20px;
  margin-bottom: 0;
  color: #8a8d93;
}

.breadcrumb a {
  color: #2186ad;
  text-decoration: none !important;
}

.breadcrumb li.active {
  color: #585a5f;
}

.breadcrumb-item + .breadcrumb-item::before {
  color: #585a5f;
}

.block {
  padding: 20px;
  background: #fff;
  color: #000000;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  margin-bottom: 30px;
}

.card {
  margin-bottom: 30px;
  box-shadow:
    2px 2px 2px rgba(0, 0, 0, 0.1),
    -1px 0 2px rgba(0, 0, 0, 0.05);
}

.card-header h1,
.card-header h2,
.card-header h3,
.card-header h4,
.card-header h5,
.card-header h6 {
  margin-bottom: 0;
}

.page-content {
  position: relative;
  background: #eceef2;
  min-height: calc(100vh - 73px);
  width: calc(100% - 222px);
  padding: 0 28px;
  padding-bottom: 70px;
}

.page-content.active {
  width: 100%;
}

.page-header {
  padding: 20px 15px;
  background: rgb(84, 178, 203);
  color: #fff;
  margin-bottom: 30px;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}

.footer .footer__block {
  min-height: 70px;
}

.dropdown-menu {
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  font-size: 1rem;
  min-width: 200px;
  background: #fff;
  border-radius: 2.5px;
  padding: 0;
  margin-top: 8px;
  border: 1px solid #f4f4f4;
}

.dropdown-menu a {
  color: inherit;
}

.dropdown-toggle {
  background: none;
  outline: none;
  border-radius: 0;
}

.dropdown-toggle span.caret {
  color: #555;
}

.dropdown-menu a {
  padding: 10px 15px;
  font-size: 0.9rem;
  text-transform: none;
}

.dropdown-submenu {
  position: relative;
}

.dropdown-submenu > .dropdown-menu {
  top: 0;
  left: 100%;
  margin-top: -2px;
  font-size: 1rem;
}

.megamenu {
  width: 100%;
  padding: 40px 30px;
  margin-top: 0 !important;
  z-index: 1100 !important;
}

.megamenu strong {
  margin-bottom: 10px;
  display: block;
}

.megamenu ul {
  padding: 0;
  margin: 0;
}

.megamenu ul a {
  padding: 5px 0 !important;
  text-decoration: none;
  color: #555;
  font-size: 0.9em !important;
}

.megamenu ul a:hover {
  background: none;
  color: #2186ad !important;
}

.megamenu .megamenu-buttons {
  color: #fff;
  margin-top: 40px;
}

.megamenu .megamenu-buttons .megamenu-button-link {
  padding: 20px !important;
  text-decoration: none;
  font-weight: 300;
}

.megamenu .megamenu-buttons .megamenu-button-link.dashbg-1:hover {
  background: #7838d5 !important;
}

.megamenu .megamenu-buttons .megamenu-button-link.dashbg-2:hover {
  background: #c83af8 !important;
}

.megamenu .megamenu-buttons .megamenu-button-link.dashbg-3:hover {
  background: #e6495d !important;
}

.megamenu .megamenu-buttons .megamenu-button-link.dashbg-4:hover {
  background: #632297 !important;
}

.block .title {
  margin-bottom: 20px;
}

.block .title strong:first-child {
  font-size: 1.25rem;
  color: #a5a7ab;
}

.block .title span:first-child {
  font-weight: 300;
  font-size: 0.95rem;
}
/*
* ==========================================================
*     NAVBAR
* ==========================================================
*/
nav.navbar {
  background: #000;
  color: #fff;
  padding: 11px 0px 10px;
  border-bottom: none;
  box-shadow: none;
  z-index: 10;
}

nav.navbar .sidebar-toggle {
  width: 36px;
  height: 36px;
  text-align: center;
  border-radius: 0%;
  background: none;
  border: none;
  outline: none;
  position: relative;
  margin: 0 10px 0 0px;
  padding: 0;
  border: none;
}

nav.navbar .sidebar-toggle .toggle-icon {
  width: 26px;
  position: relative;
  display: block;
  height: 2px;
  background: #707070;
  border-radius: 4px;
}

nav.navbar .sidebar-toggle .toggle-icon:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: -8px;
  height: 2px;
  background: #707070;
  border-radius: 4px;
  transition: 0.25s ease-out;
}

nav.navbar .sidebar-toggle .toggle-icon:after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 8px;
  height: 2px;
  background: #707070;
  border-radius: 4px;
  transition: 0.25s ease-out;
}

.sideMenuFixed nav.navbar .sidebar-toggle .toggle-icon:before {
  transform: rotate(-35deg);
  left: -1px;
  width: 15px;
  right: auto;
  top: -4.3px;
}

.sideMenuFixed nav.navbar .sidebar-toggle .toggle-icon:after {
  transform: rotate(35deg);
  left: -1px;
  width: 15px;
  right: auto;
  top: 4.4px;
}

nav.navbar a {
  color: inherit;
}

nav.navbar .brand-text {
  display: none;
  font-weight: 700;
}

nav.navbar .brand-text.visible {
  display: block;
}

nav.navbar a.nav-link {
  padding: 0.5rem 0.3rem;
  position: relative;
}

nav.navbar .nav-link .badge {
  width: 10px;
  height: 10px;
  text-align: center;
  border-radius: 50%;
  padding: 0;
  font-size: 0.7rem;
  position: absolute;
  top: 1px;
  right: 12px;
  background: #dd0a0a;
}

nav.navbar .messages-toggle,
nav.navbar .tasks-toggle {
  margin-right: 15px;
}

nav.navbar .menu-large {
  position: static !important;
}

nav.navbar .search-panel {
  display: none;
}

nav.navbar .search-inner {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(45, 48, 53, 0.95);
  z-index: 9;
}

nav.navbar .search-inner .close-btn {
  position: absolute;
  top: 20px;
  right: 40px;
  font-size: 1.1em;
  font-weight: 400;
  cursor: pointer;
}

nav.navbar .search-inner form {
  width: 100%;
  max-width: 800px;
  padding: 20px;
}

nav.navbar .search-inner .form-group {
  position: relative;
}

nav.navbar .search-inner .submit {
  background: none;
  font-size: 2.3rem;
  position: absolute;
  right: 0;
  bottom: 0;
  color: #8a8d93;
  border: none;
  font-weight: 700 !important;
}

nav.navbar .search-inner input {
  background: none;
  width: 100%;
  font-size: 2rem;
  border: none;
  border-bottom: 1px solid #444951;
  color: #8a8d93;
}

nav.navbar .search-inner input::-moz-placeholder {
  /* font-family: "Muli", sans-serif; 
  font-weight: 300 !important; */
  color: #585a5f;
}

nav.navbar .search-inner input::-webkit-input-placeholder {
  /* font-family: "Muli", sans-serif;
  font-weight: 300 !important; */
  color: #535353;
}

nav.navbar .search-inner input:-ms-input-placeholder {
  /* font-family: "Muli", sans-serif; 
  font-weight: 300 !important; */
  color: #535353;
}

nav.navbar .dropdown-menu {
  min-width: 300px;
  left: auto;
  right: 0;
  inset-inline-start: auto !important;
}

nav.navbar .dropdown-item {
  padding: 1rem;
  border-bottom: 1px solid rgba(112, 112, 112, 0.16);
}

nav.navbar .dropdown-item:hover {
  background: #ededed;
  color: #000;
}

nav.navbar .dropdown-item:last-of-type {
  border-bottom: none;
}

nav.navbar .dropdown-item.message {
  color: #464646;
  text-decoration: none;
}

nav.navbar .dropdown-item.message li:last-of-type a {
  border-bottom: none;
}

nav.navbar .dropdown-item.message .profile {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 15px;
  position: relative;
}

nav.navbar .dropdown-item.message .profile img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

nav.navbar .dropdown-item.message .profile .status {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #fff;
  position: absolute;
  top: 2px;
  right: 2px;
}

nav.navbar .dropdown-item.message .profile .status.online {
  background: #28a745;
}

nav.navbar .dropdown-item.message .profile .status.away {
  background: #ffc107;
}

nav.navbar .dropdown-item.message .profile .status.busy {
  background: #dc3545;
}

nav.navbar .dropdown-item.message .profile .status.offline {
  background: #999;
}

nav.navbar .dropdown-item.message .content strong {
  font-size: 1rem;
}

nav.navbar .dropdown-item.message .content span {
  font-weight: 300;
  font-size: 0.85rem;
}

nav.navbar .dropdown-item.message .content .date {
  color: #70737a;
}

nav.navbar .tasks-list strong {
  font-size: 1rem;
}

nav.navbar .tasks-list span {
  font-size: 0.95rem;
}

nav.navbar .tasks-list .progress {
  height: 2px;
  margin-top: 10px;
  background: #444951;
}

nav.navbar a.language span {
  margin-left: 0.2rem;
  vertical-align: middle;
}

/* Navbar dropdown effect */
nav.navbar .dropdown .dropdown-menu {
  transition: all 0.3s ease-in-out;
}

nav.navbar .dropdown .dropdown-menu.active {
  transform: translateY(0);
}

/* Navbar Media Query ----------------------------------- */
@media (max-width: 1331px) {
  nav.navbar .right-menu {
    margin-bottom: -3px;
  }

  nav.navbar .navbar-brand {
    margin-right: 5px;
  }

  nav.navbar .search-inner form input {
    font-size: 1.25rem !important;
  }

  nav.navbar .search-inner form button.submit {
    position: absolute;
    font-size: 2rem;
    top: 50px;
    display: block;
    width: 100%;
  }

  nav.navbar .brand-text {
    display: none !important;
  }

  nav.navbar .brand-text.visible {
    display: none !important;
  }

  nav.navbar .brand-text.brand-sm {
    display: block !important;
  }
}

@media (max-width: 991px) {
  nav.navbar .dropdown-menu {
    right: -140px;
  }

  nav.navbar .megamenu {
    right: 0 !important;
  }

  nav.navbar a.nav-link {
    font-size: 0.85rem;
  }

  nav.navbar .nav-link .badge {
    width: 16px;
    height: 16px;
    line-height: 16px;
    color: #fff;
    text-align: center;
    font-size: 0.6rem;
  }
}

@media (max-width: 575px) {
  nav.navbar .dropdown {
    position: static;
  }

  nav.navbar .dropdown-menu {
    width: 90vw;
    right: 2.5vw;
    left: 2.5vw;
    margin: 0 auto;
  }
}

/*************************Side nav*******************************/

nav#sidebar {
  width: 222px;
  /* margin-top: 60px; */
  /* background: #2d3035; */
  color: #7b7a7a;
  /* border-right: 1px solid #34373d; */
  /* shrinked navbar */
  background-color: #fff;
  position: relative;
  padding-bottom: 90px;
}

nav#sidebar a {
  color: inherit;
  text-decoration: none;
  position: relative;
}

nav#sidebar a[aria-haspopup="menu"]::after,
nav#sidebar button[aria-haspopup="menu"]::after {
  content: "\\e901";
  display: inline-block;
  transform: translateY(-50%);
  font-family: "icomoon" !important;
  position: absolute;
  top: 50%;
  right: 20px;
  font-size: 11px;
}

nav#sidebar a[aria-haspopup="menu"][aria-expanded="true"]::after,
nav#sidebar button[aria-haspopup="menu"][aria-expanded="true"]::after {
  transform: translateY(-50%) rotate(180deg);
}

nav#sidebar.shrinked a[aria-haspopup="menu"]::after {
  content: "\\f107";
  transform: translate(-50%, -50%);
  position: absolute;
  top: 90%;
  left: 50%;
}

nav#sidebar.shrinked a[aria-haspopup="menu"][aria-expanded="true"]::after {
  content: "\\f106";
}

nav#sidebar span.heading {
  font-weight: 700;
  margin-left: 20px;
  color: #494d53;
  font-size: 1.2rem;
  margin-bottom: 15px;
}

nav#sidebar .avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 15px;
  background: none;
  padding: 4px;
}

nav#sidebar.shrinked .avatar {
  margin-right: 0px;
}

nav#sidebar ul {
  max-height: none;
  padding-bottom: 0px;
}

nav#sidebar li {
  position: relative;
  margin: 0px;
}

/* nav#sidebar .sgds.sidenav li.sidenav-item:last-child {
  position: absolute;
  bottom: 30px;
  left: 0;
  right: 0;
} */

/* nav#sidebar .sgds.sidenav li.sidenav-item:last-child {
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 20px 0 0 0;
} */

nav#sidebar li a {
  padding: 12px 12px;
  display: block;
  font-size: 15px;
  font-weight: 400;
  position: relative;
  z-index: 1;
  border: none;
  color: #7b7a7a;
  line-height: normal;
  border-radius: 3px;
  display: flex;
  align-items: center;
}

nav#sidebar li a .icon,
nav#sidebar li > .btn.sgds .icon {
  margin: 0 7px 0 0;
  font-size: 16px;
  flex: 0 0 20px;
}

nav#sidebar li a .icon.icon-user-management,
nav#sidebar li a .icon.icon-team-management,
nav#sidebar li a .icon.icon-profile-settings,
nav#sidebar li a .icon.icon-help,
nav#sidebar li a .icon.icon-settings {
  font-size: 17px;
}

nav#sidebar li a .icon.icon-leaderboard {
  font-size: 18px;
}

nav#sidebar li a:hover {
  color: #09a752;
}

nav#sidebar li a:focus {
  box-shadow: none;
}

nav#sidebar li a[aria-expanded="true"]:before {
  opacity: 1;
}

nav#sidebar li.selected .sidenav-collapse li a.active:before,
nav#sidebar li.selected .sidenav-collapse li a.active:hover:before {
  background: #10688b;
  opacity: 1;
}

#sidebar .sidenav-collapse {
  margin: 0px;
}

nav#sidebar li.active > a {
  background: rgba(3, 189, 90, 0.18);
  color: #0ca751;
  font-weight: bold;
}

nav#sidebar li li.active > a {
  background: rgb(84, 178, 203);
}

nav#sidebar li > .btn.sgds {
  padding: 12px 12px;
  font-size: 15px;
  font-weight: 400;
  position: relative;
  z-index: 1;
  border: none;
  color: #7b7a7a;
  line-height: normal;
  border-radius: 3px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-start;
}

nav#sidebar li.active > .btn.sgds {
  background: rgba(3, 189, 90, 0.18);
  color: #0ca751;
  font-weight: bold;
}

nav#sidebar li > .btn.sgds:focus {
  outline: none;
  box-shadow: none;
}

nav#sidebar li.active > .btn.sgds .icon-traininig {
  font-size: 18px;
}

nav#sidebar li .sidenav-collapse ul li a {
  font-size: 14px;
  padding: 9px 12px 9px 20px;
}

nav#sidebar.shrinked {
  width: 80px;
}

nav#sidebar.shrinked span.heading {
  margin-left: 0;
  display: block;
  text-align: center;
  font-size: 1rem;
}

nav#sidebar.shrinked ul {
  max-height: none;
}

nav#sidebar.shrinked ul a {
  padding: 14px 5px;
  display: block;
  font-weight: 400;
  text-align: center;
  font-size: 0.8rem;
  word-break: break-word;
}

nav#sidebar.shrinked ul i {
  font-size: 1.2rem;
  text-align: center !important;
  width: 100%;
  display: block !important;
  border: none !important;
  padding: 0 !important;
}

nav#sidebar.shrinked ul ul a {
  padding-left: 10px;
}

nav#sidebar.shrinked a[data-bs-toggle="collapse"]::after {
  content: "\\f107";
  transform: translate(-50%, -50%);
  position: absolute;
  top: 88%;
  left: 50%;
}

nav#sidebar.shrinked a[aria-expanded="true"]::after {
  content: "\\f106";
}

/* Sidebar Media Query ----------------------------------- */

@media (min-width: 991px) {
  nav#sidebar {
    transition:
      margin,
      0.25s ease-out;
    margin-left: 0px;
    flex: 0 0 222px;
  }

  .sideMenuFixed nav#sidebar {
    margin-left: 0px;
  }

  nav#sidebar + .page-content {
    /* width: auto; */
    flex: auto;
  }

  nav.navbar .sidebar-toggle {
    display: none;
  }
}

@media (max-width: 991px) {
  .page-content {
    width: 100%;
  }

  .page-content.active {
    width: calc(100% - 80px);
  }

  nav#sidebar {
    /* width: 15%; */
    margin-left: 0px;
    flex: 0 0 222px;
    position: fixed;
    left: -222px;
    top: 68.79px;
    bottom: 0;
    transition:
      left,
      0.25s ease-out;
    z-index: 99;
  }

  .sideBarSticky {
    height: calc(100vh - 73px);
    overflow-y: auto;
  }

  .sideMenuFixed nav#sidebar {
    left: 0;
  }

  nav#sidebar li a {
    padding: 16px 18px;
    font-size: 14px;
  }

  nav#sidebar li a i,
  nav#sidebar li button.btn i {
    margin: -2px 7px 0px 0;
  }

  nav.navbar .dropdown {
    border-left: none;
    margin-left: 8px;
  }

  nav.navbar .sidebar-toggle {
    margin: 0 0 0 10px;
  }

  nav#sidebar span.heading {
    margin-left: 0;
    display: block;
    text-align: center;
    font-size: 1rem;
  }

  nav#sidebar ul {
    max-height: none;
  }

  /* nav#sidebar ul a {
    padding: 12px 5px;
    display: block;
    font-weight: 400;
    text-align: center;
    font-size: 0.8rem;
  }

  nav#sidebar ul i {
    font-size: 1.2rem;
    text-align: center !important;
    width: 100%;
    display: block !important;
    border: none !important;
    padding: 0 !important;
  } */

  /* nav#sidebar ul ul a {
    padding-left: 10px;
  }

  nav#sidebar.shrinked {
    margin-left: 0;
  }

  nav#sidebar a[data-bs-toggle="collapse"]::after {
    content: "\\f107";
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    position: absolute;
    top: 88%;
    left: 50%;
  }

  nav#sidebar a[aria-expanded="true"]::after {
    content: "\\f106";
  }  */
}

/***********************dashboard****************************/
.bredcrumb {
  padding: 16px 0;
}

.bredcrumb ul {
  padding: 0;
  display: flex;
  align-items: center;
  margin: 0px;
}

.bredcrumb ul li {
  list-style: none;
  color: #0ca751;
  font-size: 14px;
  padding: 0;
  position: relative;
}

.bredcrumb ul li + li {
  margin: 0 0 0 10px;
  padding: 0 0 0 12px;
}

.bredcrumb ul li + li::before {
  content: "\\e903";
  font-family: "icomoon", sans-serif !important;
  transform: rotate(90deg);
  position: absolute;
  left: -3px;
  color: #0ca751;
  font-size: 10px;
  top: 2.2px;
}

.bredcrumb ul li a {
  list-style: none;
  color: #7b7a7a !important;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.loginTrBg {
  background: #ffc566;
  position: relative;
  padding: 120px 0px;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.loginTrBg::before {
  content: "";
  position: absolute;
  left: -5%;
  right: -5%;
  top: -30%;
  bottom: 50%;
  background: #fff;
  transform: rotate(-5deg);
}

.loginTrBg .loginTrBgIn {
  max-width: 430px;
  flex: 0 0 460px;
  position: relative;
  z-index: 1;
}

.loginTrBg .loginTrBgIn .card {
  background: #fff;
  box-shadow: 0px 3px 6px 2px rgba(0, 0, 0, 0.16);
  border-radius: 0;
  margin: 0;
}

.loginTrBg .loginTrBgIn .card .card-body {
  padding: 40px;
}

.loginTitleWrap {
  margin: 0 0 24px 0;
}

.loginTitleWrap h5 {
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 0px 0;
  color: #000;
}

.loginTitleWrap p {
  font-size: 14px;
  font-weight: 400;
  margin: 6px 0 0px 0;
  color: rgba(114, 114, 114, 0.9);
  line-height: 19.5px;
}

.loginTrBg .loginTrBgIn .form-group {
  margin: 0 0 24px 0;
}

.loginTrBg .loginTrBgIn .form-group label {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 4px 0;
}

.loginTrBg .loginTrBgIn .form-group .form-control {
  font-size: 17px;
  font-weight: 400;
  color: #000;
  padding: 0 16px 0 16px;
  text-shadow: none;
  height: 51px;
  border: 0.5px solid rgba(192, 192, 192, 0.4);
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  background: #fff;
}

.btn {
  border-radius: 5px;
  padding: 11px 18px;
  font-size: 15px;
  font-weight: 500;
}

.btn.btn-sm {
  border-radius: 4px;
  padding: 9px 18px;
  font-size: 15px;
}

.loginTrBg .loginTrBgIn .btn {
  padding: 14px 18px;
  font-size: 15px;
  font-weight: 700;
}

.mapFiltersBar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 16px 24px;
  border-radius: 4px;
  gap: 14px;
}

.mapFiltersBar h5 {
  font-size: 24px;
  font-weight: 600;
  margin: 0px;
}

.mapFiltersBar h5 {
  font-size: 18px;
  font-weight: 600;
}

.mapFiltersBar select {
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.3);
  height: 40px;
}

.whiteContBar {
  background: #fff;
  border-radius: 5px;
  padding: 18px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card.hptCard .card-header {
  padding: 22px 30px;
}

.card.hptCard .card-footer {
  padding: 22px 30px;
}

.card.hptCard .card-body {
  padding: 22px 30px;
}

.cardTitle h5 {
  font-size: 18px;
  font-weight: 700;
  color: #000;
  margin: 0 0 3px 0;
  line-height: 1.1;
}

.cardTitle p {
  font-size: 16px;
  font-weight: 400;
  color: #343434;
  margin: 0 0 0px 0;
  line-height: 1.5;
}

.card .card-header {
  background: transparent;
}

.filterList {
  background: #f2f4fb;
  padding: 14px 24px;
  border: 1px solid #dfe2ec;
  position: relative;
  cursor: pointer;
  height: 100%;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.filterList:hover {
  background: #dce1f2;
}

.filterList .card-title {
  margin: 0px;
  font-size: 17px;
  font-weight: 700;
}

.filterList .card-text {
  margin: 0px;
  font-size: 14px;
  font-weight: 400;
  color: #7b7979;
}

.filterList.bg-success {
  border-color: #198754;
}

.filterList.bg-success .card-text {
  color: rgba(255, 255, 255, 0.8);
}

/* .card.hptCard.mt-4 {
    min-height: calc(100% - 1.5rem);
  } */

.card .table td,
.card .table th {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 16px;
  padding-bottom: 16px;
}

.card .table td:first-child,
.card .table th:first-child {
  padding-left: 28px;
}

.table .thead-light th {
  background-color: #e4e6ed;
  color: #343434;
  font-size: 15px;
  text-transform: none;
  font-weight: 400;
}

.table-bordered > :not(caption) > * {
  border-color: #dcdcdc;
}

.table td {
  color: #343434;
  font-size: 15px;
  text-transform: none;
  font-weight: 400;
  border-color: #dcdcdc;
}

.table td.table-secondary {
  background: #eeeeee;
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
  border-color: #dcdcdc;
}

.table td input {
  color: #000000;
  padding: 0 16px;
  font-size: 14px;
  width: 100%;
  height: 42px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0;
  box-shadow: inset 0 0px 6px rgba(0, 0, 0, 0.14);
}

.headnumText {
  display: flex;
  align-items: center;
  gap: 14px;
}

.headnumText .cardDropDown {
  display: flex;
  align-items: center;
}

.pageTitle {
  padding: 24px 0 12px;
  font-size: 16px;
  font-weight: 400;
  color: #000;
}

.pageTitleWrap {
  padding: 24px 0 12px;
}

.pageTitleWrap h5 {
  font-size: 18px;
  font-weight: 500;
  color: #000;
  margin: 0 0 5px 0;
  line-height: 1.2;
}

.pageTitleWrap p {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.2;
  margin: 0px;
  font-weight: 400;
}

.bg-theme-light {
  position: relative;
  /* background: #f2f4fb; */
  z-index: 1;
  min-height: calc(100vh - 106px);
}

.bg-theme-light::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  background: #fae466;
  height: 100%;
  z-index: -1;
}

.loginTrBg.afterLogin {
  background: #ffecce;
}

.loginTrBg.afterLogin:before {
  display: none;
}

.form-navigate-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #dee2e6;
  margin: 0 -1rem;
  padding: 4px 20px 14px;
}

.form-navigate-block .pageName {
  display: flex;
  align-items: center;
  font-weight: 600;
}

.form-navigate-block .pageName .number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  background: rgba(38, 81, 202, 0.1);
  margin: 0 10px 0 0;
  border-radius: 100px;
  font-weight: 600;
  font-size: 18px;
  color: #2651ca;
}

.form-navigate-block .pageName.pending .number {
  background: none;
  width: auto;
  height: auto;
  font-size: 14px;
  color: #665f53;
}

.form-navigate-block .pageName.pending {
  font-size: 15px;
  color: #665f53;
}

.form-navigator-body {
  padding: 24px 10px;
}

.form-navigate-footer {
  border-top: 1px solid #dee2e6;
  margin: 0 -1rem;
  padding: 16px 20px 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
}

.form-navigate-footer .btn.btn-outline-secondary {
  border: 1px solid #000000;
  color: #000000;
  opacity: 1;
  padding: 7px 20px;
}

.form-navigate-footer .btn.btn-outline-secondary:hover {
  background: #dee3f0;
  color: #45474c;
  border-color: #d0d5e2;
}

.form-navigate-footer .btn {
  padding: 8px 20px;
  min-width: 100px;
  border-radius: 4px;
}

.form-group {
  margin: 0 0 20px;
}
.form-group label {
  font-size: 14px;
  color: #000000;
  margin: 0 0 4px 0;
  display: block;
}

.form-group input {
  font-size: 14px;
  color: #000000;
  padding: 0 16px;
  width: 100%;
  height: 48px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;

  box-shadow: inset 0 0px 6px rgba(0, 0, 0, 0.14);
}

.custom-select select {
  font-size: 14px;
  color: #000000;
  padding: 0 16px;
  width: 100%;
  height: 48px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 0.7em;
  background-position: calc(100% - 1.3em) center;
  background-repeat: no-repeat;
  border-radius: 4px;
  box-shadow: none;
  outline: none;
  box-shadow: inset 0 0px 6px rgba(0, 0, 0, 0.14);
}

.custom-select select:focus,
.custom-select select:active {
  box-shadow: none;
}

.referenceText {
  font-size: 13px;
  font-style: italic;
  font-weight: 600;
}

.secTitle h5 {
  font-size: 15px;
  font-weight: 600;
  margin: 8px 0 14px 0;
}

.custom-radio.form-check {
  position: relative;
  margin: 0px;
  padding: 0px;
}

body .custom-radio .form-check-input {
  margin: 0px;
  cursor: pointer;
  accent-color: #ffecce;
  position: absolute;
  left: 0;
  top: 2px;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.custom-radio .form-check-label {
  margin: 0;
  cursor: pointer;
  font-size: 15px;
  padding: 0 0 0 28px;
  margin: 0px;
}

.custom-radio .form-check-label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 2px;
  width: 20px;
  height: 20px;
  border-radius: 100px;
  border: 1px solid #ccc;
}

.custom-radio .form-check-label:after {
  content: "";
  position: absolute;
  left: 4px;
  top: 6px;
  width: 12px;
  height: 12px;
  border-radius: 100px;
  background: #2651d6;
  transform: scale(0);
  transition: 0.25s ease-out;
}

.custom-radio .form-check-input:checked + .form-check-label:after {
  transform: scale(1);
}

.cursor-pointer {
  cursor: pointer;
}

.back-nav {
  background: inherit;
  border: none;
  color: black !important;
  text-decoration: none;
}

.export-col {
  flex: 0 0 20% !important;
  max-width: 20% !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
}

.export-col .form-select {
  width: 100% !important;
  min-width: 0 !important;
}

.export-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

table,
th,
td {
  border: 1px solid black !important;
  border-collapse: collapse;
}
td:not(:first-child),
th:not(:first-child) {
  text-align: center;
}

table {
  width: 100%;
  table-layout: fixed;
}

table th,
table td {
  white-space: normal; /* ✅ allow wrapping */
  word-wrap: break-word; /* ✅ break long words */
  overflow: visible; /* ✅ no clipping */
}

.table-scroll {
  overflow-x: auto;
}

.table-scroll table {
  border-collapse: collapse;
  table-layout: auto; /* IMPORTANT: remove fixed */
  width: max-content; /* allow natural expansion */
}

.table-scroll th,
.table-scroll td {
  max-width: 120px;
  min-width: 120px; /* uniform readable width */
  padding: 8px;
  text-align: center;
  white-space: normal; /* allow wrapping */
  word-break: break-word;
}

/* Apply alternating color to every pair */
/* Skip column 1 (Place) and 2 (TOTAL VISITS if single) */
/* Pair 1 */
.table-scroll th:nth-child(3),
.table-scroll td:nth-child(3) {
  background-color: #cfeeff; /* slightly darker */
}
.table-scroll th:nth-child(4),
.table-scroll td:nth-child(4) {
  background-color: #d9f2ff;
}

/* Pair 2 */
.table-scroll th:nth-child(5),
.table-scroll td:nth-child(5) {
  background-color: #d2efd2;
}
.table-scroll th:nth-child(6),
.table-scroll td:nth-child(6) {
  background-color: #dff5df;
}

/* Pair 3 */
.table-scroll th:nth-child(7),
.table-scroll td:nth-child(7) {
  background-color: #ffefb3;
}
.table-scroll th:nth-child(8),
.table-scroll td:nth-child(8) {
  background-color: #fff4cc;
}

/* Pair 4 */
.table-scroll th:nth-child(9),
.table-scroll td:nth-child(9) {
  background-color: #d9d2ff;
}
.table-scroll th:nth-child(10),
.table-scroll td:nth-child(10) {
  background-color: #e6e0ff;
}

/* Pair 5 */
.table-scroll th:nth-child(11),
.table-scroll td:nth-child(11) {
  background-color: #ffd9e6;
}
.table-scroll th:nth-child(12),
.table-scroll td:nth-child(12) {
  background-color: #ffe6f0;
}

/* Pair 6 */
.table-scroll th:nth-child(13),
.table-scroll td:nth-child(13) {
  background-color: #ccf2f5;
}
.table-scroll th:nth-child(14),
.table-scroll td:nth-child(14) {
  background-color: #e0f7fa;
}

/* Pair 7 */
.table-scroll th:nth-child(15),
.table-scroll td:nth-child(15) {
  background-color: #e6f2d9;
}
.table-scroll th:nth-child(16),
.table-scroll td:nth-child(16) {
  background-color: #f1f8e9;
}

/* Pair 8 */
.table-scroll th:nth-child(17),
.table-scroll td:nth-child(17) {
  background-color: #ffe0eb;
}
.table-scroll th:nth-child(18),
.table-scroll td:nth-child(18) {
  background-color: #fff0f5;
}

/* Pair 9 */
.table-scroll th:nth-child(19),
.table-scroll td:nth-child(19) {
  background-color: #d9f0da;
}
.table-scroll th:nth-child(20),
.table-scroll td:nth-child(20) {
  background-color: #e8f5e9;
}

/* Pair 10 */
.table-scroll th:nth-child(21),
.table-scroll td:nth-child(21) {
  background-color: #e0d9f2;
}
.table-scroll th:nth-child(22),
.table-scroll td:nth-child(22) {
  background-color: #ede7f6;
}

/* Pair 11 */
.table-scroll th:nth-child(23),
.table-scroll td:nth-child(23) {
  background-color: #f9d6e2;
}
.table-scroll th:nth-child(24),
.table-scroll td:nth-child(24) {
  background-color: #fce4ec;
}

/* Pair 12 */
.table-scroll th:nth-child(25),
.table-scroll td:nth-child(25) {
  background-color: #d6e9fc;
}
.table-scroll th:nth-child(26),
.table-scroll td:nth-child(26) {
  background-color: #e3f2fd;
}

/* Container spacing */
.custom-tabs {
  border-bottom: 1px solid #e5e7eb;
}

/* Default tab */
.custom-tabs .nav-link {
  border: none;
  color: #010205;
  font-weight: 500;
  padding: 10px 16px;
  position: relative;
  transition: all 0.1s ease;
}

/* Hover effect */
.custom-tabs .nav-link:hover {
  color: #0d6efd;
  background: transparent;
}

/* Active tab */
.custom-tabs .nav-link.active {
  color: #0d6efd;
  font-weight: 600;
  background: transparent;
}

/* Animated underline */
.custom-tabs .nav-link::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 0%;
  height: 3px;
  background-color: rgb(250 228 102);
  transition: width 0.1s ease;
}
.custom-tabs .nav-link.active::after {
  width: 100%;
}

/* Wrapper for spacing */
.custom-tabs-wrapper {
  background: #f8f9fb;
  padding: 8px 12px;
  border-radius: 10px;
}

/* Tabs container */
.custom-tabs {
  border-bottom: none !important;
  gap: 6px;
}

/* Default tab */
.custom-tabs .nav-link {
  border: none !important;
  border-radius: 8px;
  padding: 8px 16px;
  color: #2d2d2d;
  font-weight: 500;
  transition: all 0.1s ease;
  position: relative;
}

/* Hover */
.custom-tabs .nav-link:hover {
  background-color: #eef2ff;
  color: #0d6efd;
}

/* Active tab */
.custom-tabs .nav-link.active {
  background: #ffffff;
  color: #0d6efd;
  font-weight: 600;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
}

/* Bottom accent line */
.custom-tabs .nav-link.active::after {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 20%;
  width: 60%;
  height: 3px;
  background: #fae466; /* yellow accent like your UI */
  border-radius: 10px;
}

/* Prevent text wrapping */
.custom-tabs .nav-link {
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/default.css"],"names":[],"mappings":"AAAA;;;;CAIC;AACD;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;GAIG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,YAAY;AACd;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EAInB;;kCAEgC;AAClC;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;CAIC;AACD;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,WAAW;EACX,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE;gCAC8B;EAC9B,cAAc;AAChB;;AAEA;EACE;gCAC8B;EAC9B,cAAc;AAChB;;AAEA;EACE;gCAC8B;EAC9B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EAEE,gCAAgC;AAClC;;AAEA;EAEE,wBAAwB;AAC1B;;AAEA,2DAA2D;AAC3D;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,cAAc;IACd,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,cAAc;EAChB;AACF;;AAEA,iEAAiE;;AAEjE;EACE,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qCAAqC;EACrC,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;EAErB,2BAA2B;EAC3B,iCAAiC;EACjC,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;;EAGE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;;;GAKG;;AAEH;;;;;;GAMG;;AAEH;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAEhB,gCAAgC;EAChC,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4DAA4D;;AAE5D;EACE;IACE;;oBAEgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,SAAS;IACT;;oBAEgB;IAChB,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;;;;;;;;;;;;;KAeG;;EAEH;;;;;;;;;;;;;;;;;;;MAmBI;AACN;;AAEA,6DAA6D;AAC7D;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6CAA6C;EAC7C,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,4CAA4C;EAC5C,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;KAEK;;AAEL;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;;EAElB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,sBAAsB;EACtB,yDAAwe;EACxe,sBAAsB;EACtB,8CAA8C;EAC9C,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,+CAA+C;AACjD;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;;;EAGE,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB,EAAE,qBAAqB;EAC1C,qBAAqB,EAAE,uBAAuB;EAC9C,iBAAiB,EAAE,kBAAkB;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB,EAAE,4BAA4B;EAChD,kBAAkB,EAAE,4BAA4B;AAClD;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB,EAAE,2BAA2B;EAC7C,YAAY;EACZ,kBAAkB;EAClB,mBAAmB,EAAE,mBAAmB;EACxC,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C,yDAAyD;AACzD,WAAW;AACX;;EAEE,yBAAyB,EAAE,oBAAoB;AACjD;AACA;;EAEE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,gCAAgC;AAClC;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,SAAS;EACT,WAAW;EACX,kCAAkC;EAClC,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,QAAQ;AACV;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;EACX,mBAAmB,EAAE,+BAA+B;EACpD,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB","sourcesContent":["/*\n* ==========================================================\n*     GENERAL STYLING\n* ==========================================================\n*/\n*/ body {\n  position: relative;\n}\n\nsection {\n  padding: 0 0.6rem;\n}\n\n/* a {\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n  display: inline-block;\n} */\n\n.topHeader {\n  background: #fff;\n}\n\n.dashtext-1 {\n  color: #864dd9 !important;\n}\n\n.dashtext-2 {\n  color: #cf53f9 !important;\n}\n\n.dashtext-3 {\n  color: #e95f71 !important;\n}\n\n.dashtext-4 {\n  color: #7127ac !important;\n}\n\n.dashbg-1 {\n  background: #864dd9;\n}\n\n.dashbg-2 {\n  background: #cf53f9;\n}\n\n.dashbg-3 {\n  background: #e95f71;\n}\n\n.dashbg-4 {\n  background: #7127ac;\n}\n\n.text-bold {\n  font-weight: 700;\n}\n\n.text-small {\n  font-size: 0.8rem;\n}\n\n.text-gray-light {\n  color: #dee2e6;\n}\n\n.text-gray {\n  color: #8a8d93;\n}\n\n.text-gray-dark {\n  color: #6a6c70;\n}\n\n.text-black {\n  color: #000;\n}\n\n.text-uppercase {\n  letter-spacing: 0.1em;\n}\n\n.lh-2 {\n  line-height: 2;\n}\n\n.list-group-item {\n  border-right: 0;\n  border-left: 0;\n}\n\n.list-group-item:first-child,\n.list-group-item:last-child {\n  border-radius: 0;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.tile-link {\n  position: absolute;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  z-index: 30;\n}\n\np {\n  line-height: 1.7;\n}\n\nbutton {\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n}\n\ni,\nspan,\nstrong {\n  display: inline-block;\n}\n\ninput {\n  outline: none;\n}\n\npre {\n  color: #8a8d93;\n}\n\n.dropdown-divider {\n  border-top-color: #6a6c70;\n}\n\n.no-padding {\n  padding: 0 !important;\n}\n\n.no-padding-top {\n  padding-top: 0 !important;\n}\n\n.no-padding-bottom {\n  padding-bottom: 0 !important;\n}\n\n.no-margin {\n  margin: 0 !important;\n}\n\n.no-margin-top {\n  margin-top: 0 !important;\n}\n\n.no-margin-bottom {\n  margin-bottom: 0 !important;\n}\n\n.padding-top-sm {\n  padding-top: 30px !important;\n}\n\n.padding-bottom-sm {\n  padding-bottom: 30px !important;\n}\n\n.margin-top-sm {\n  margin-top: 30px !important;\n}\n\n.margin-bottom-sm {\n  margin-bottom: 30px !important;\n}\n\n.breadcrumb {\n  background: none;\n  padding: 20px 20px;\n  margin-bottom: 0;\n  color: #8a8d93;\n}\n\n.breadcrumb a {\n  color: #2186ad;\n  text-decoration: none !important;\n}\n\n.breadcrumb li.active {\n  color: #585a5f;\n}\n\n.breadcrumb-item + .breadcrumb-item::before {\n  color: #585a5f;\n}\n\n.block {\n  padding: 20px;\n  background: #fff;\n  color: #000000;\n  border: 1px solid #e8e8e8;\n  border-radius: 4px;\n  margin-bottom: 30px;\n}\n\n.card {\n  margin-bottom: 30px;\n  -webkit-box-shadow:\n    2px 2px 2px rgba(0, 0, 0, 0.1),\n    -1px 0 2px rgba(0, 0, 0, 0.05);\n  box-shadow:\n    2px 2px 2px rgba(0, 0, 0, 0.1),\n    -1px 0 2px rgba(0, 0, 0, 0.05);\n}\n\n.card-header h1,\n.card-header h2,\n.card-header h3,\n.card-header h4,\n.card-header h5,\n.card-header h6 {\n  margin-bottom: 0;\n}\n\n.page-content {\n  position: relative;\n  background: #eceef2;\n  min-height: calc(100vh - 73px);\n  width: calc(100% - 222px);\n  padding: 0 28px;\n  padding-bottom: 70px;\n}\n\n.page-content.active {\n  width: 100%;\n}\n\n.page-header {\n  padding: 20px 15px;\n  background: rgb(84, 178, 203);\n  color: #fff;\n  margin-bottom: 30px;\n}\n\n.footer {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n}\n\n.footer .footer__block {\n  min-height: 70px;\n}\n\n.dropdown-menu {\n  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);\n  font-size: 1rem;\n  min-width: 200px;\n  background: #fff;\n  border-radius: 2.5px;\n  padding: 0;\n  margin-top: 8px;\n  border: 1px solid #f4f4f4;\n}\n\n.dropdown-menu a {\n  color: inherit;\n}\n\n.dropdown-toggle {\n  background: none;\n  outline: none;\n  border-radius: 0;\n}\n\n.dropdown-toggle span.caret {\n  color: #555;\n}\n\n.dropdown-menu a {\n  padding: 10px 15px;\n  font-size: 0.9rem;\n  text-transform: none;\n}\n\n.dropdown-submenu {\n  position: relative;\n}\n\n.dropdown-submenu > .dropdown-menu {\n  top: 0;\n  left: 100%;\n  margin-top: -2px;\n  font-size: 1rem;\n}\n\n.megamenu {\n  width: 100%;\n  padding: 40px 30px;\n  margin-top: 0 !important;\n  z-index: 1100 !important;\n}\n\n.megamenu strong {\n  margin-bottom: 10px;\n  display: block;\n}\n\n.megamenu ul {\n  padding: 0;\n  margin: 0;\n}\n\n.megamenu ul a {\n  padding: 5px 0 !important;\n  text-decoration: none;\n  color: #555;\n  font-size: 0.9em !important;\n}\n\n.megamenu ul a:hover {\n  background: none;\n  color: #2186ad !important;\n}\n\n.megamenu .megamenu-buttons {\n  color: #fff;\n  margin-top: 40px;\n}\n\n.megamenu .megamenu-buttons .megamenu-button-link {\n  padding: 20px !important;\n  text-decoration: none;\n  font-weight: 300;\n}\n\n.megamenu .megamenu-buttons .megamenu-button-link.dashbg-1:hover {\n  background: #7838d5 !important;\n}\n\n.megamenu .megamenu-buttons .megamenu-button-link.dashbg-2:hover {\n  background: #c83af8 !important;\n}\n\n.megamenu .megamenu-buttons .megamenu-button-link.dashbg-3:hover {\n  background: #e6495d !important;\n}\n\n.megamenu .megamenu-buttons .megamenu-button-link.dashbg-4:hover {\n  background: #632297 !important;\n}\n\n.block .title {\n  margin-bottom: 20px;\n}\n\n.block .title strong:first-child {\n  font-size: 1.25rem;\n  color: #a5a7ab;\n}\n\n.block .title span:first-child {\n  font-weight: 300;\n  font-size: 0.95rem;\n}\n/*\n* ==========================================================\n*     NAVBAR\n* ==========================================================\n*/\nnav.navbar {\n  background: #000;\n  color: #fff;\n  padding: 11px 0px 10px;\n  border-bottom: none;\n  box-shadow: none;\n  z-index: 10;\n}\n\nnav.navbar .sidebar-toggle {\n  width: 36px;\n  height: 36px;\n  text-align: center;\n  border-radius: 0%;\n  background: none;\n  border: none;\n  outline: none;\n  position: relative;\n  margin: 0 10px 0 0px;\n  padding: 0;\n  border: none;\n}\n\nnav.navbar .sidebar-toggle .toggle-icon {\n  width: 26px;\n  position: relative;\n  display: block;\n  height: 2px;\n  background: #707070;\n  border-radius: 4px;\n}\n\nnav.navbar .sidebar-toggle .toggle-icon:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: -8px;\n  height: 2px;\n  background: #707070;\n  border-radius: 4px;\n  transition: 0.25s ease-out;\n}\n\nnav.navbar .sidebar-toggle .toggle-icon:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 8px;\n  height: 2px;\n  background: #707070;\n  border-radius: 4px;\n  transition: 0.25s ease-out;\n}\n\n.sideMenuFixed nav.navbar .sidebar-toggle .toggle-icon:before {\n  transform: rotate(-35deg);\n  left: -1px;\n  width: 15px;\n  right: auto;\n  top: -4.3px;\n}\n\n.sideMenuFixed nav.navbar .sidebar-toggle .toggle-icon:after {\n  transform: rotate(35deg);\n  left: -1px;\n  width: 15px;\n  right: auto;\n  top: 4.4px;\n}\n\nnav.navbar a {\n  color: inherit;\n}\n\nnav.navbar .brand-text {\n  display: none;\n  font-weight: 700;\n}\n\nnav.navbar .brand-text.visible {\n  display: block;\n}\n\nnav.navbar a.nav-link {\n  padding: 0.5rem 0.3rem;\n  position: relative;\n}\n\nnav.navbar .nav-link .badge {\n  width: 10px;\n  height: 10px;\n  text-align: center;\n  border-radius: 50%;\n  padding: 0;\n  font-size: 0.7rem;\n  position: absolute;\n  top: 1px;\n  right: 12px;\n  background: #dd0a0a;\n}\n\nnav.navbar .messages-toggle,\nnav.navbar .tasks-toggle {\n  margin-right: 15px;\n}\n\nnav.navbar .menu-large {\n  position: static !important;\n}\n\nnav.navbar .search-panel {\n  display: none;\n}\n\nnav.navbar .search-inner {\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(45, 48, 53, 0.95);\n  z-index: 9;\n}\n\nnav.navbar .search-inner .close-btn {\n  position: absolute;\n  top: 20px;\n  right: 40px;\n  font-size: 1.1em;\n  font-weight: 400;\n  cursor: pointer;\n}\n\nnav.navbar .search-inner form {\n  width: 100%;\n  max-width: 800px;\n  padding: 20px;\n}\n\nnav.navbar .search-inner .form-group {\n  position: relative;\n}\n\nnav.navbar .search-inner .submit {\n  background: none;\n  font-size: 2.3rem;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  color: #8a8d93;\n  border: none;\n  font-weight: 700 !important;\n}\n\nnav.navbar .search-inner input {\n  background: none;\n  width: 100%;\n  font-size: 2rem;\n  border: none;\n  border-bottom: 1px solid #444951;\n  color: #8a8d93;\n}\n\nnav.navbar .search-inner input::-moz-placeholder {\n  /* font-family: \"Muli\", sans-serif; \n  font-weight: 300 !important; */\n  color: #585a5f;\n}\n\nnav.navbar .search-inner input::-webkit-input-placeholder {\n  /* font-family: \"Muli\", sans-serif;\n  font-weight: 300 !important; */\n  color: #535353;\n}\n\nnav.navbar .search-inner input:-ms-input-placeholder {\n  /* font-family: \"Muli\", sans-serif; \n  font-weight: 300 !important; */\n  color: #535353;\n}\n\nnav.navbar .dropdown-menu {\n  min-width: 300px;\n  left: auto;\n  right: 0;\n  inset-inline-start: auto !important;\n}\n\nnav.navbar .dropdown-item {\n  padding: 1rem;\n  border-bottom: 1px solid rgba(112, 112, 112, 0.16);\n}\n\nnav.navbar .dropdown-item:hover {\n  background: #ededed;\n  color: #000;\n}\n\nnav.navbar .dropdown-item:last-of-type {\n  border-bottom: none;\n}\n\nnav.navbar .dropdown-item.message {\n  color: #464646;\n  text-decoration: none;\n}\n\nnav.navbar .dropdown-item.message li:last-of-type a {\n  border-bottom: none;\n}\n\nnav.navbar .dropdown-item.message .profile {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  margin-right: 15px;\n  position: relative;\n}\n\nnav.navbar .dropdown-item.message .profile img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n}\n\nnav.navbar .dropdown-item.message .profile .status {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  border: 2px solid #fff;\n  position: absolute;\n  top: 2px;\n  right: 2px;\n}\n\nnav.navbar .dropdown-item.message .profile .status.online {\n  background: #28a745;\n}\n\nnav.navbar .dropdown-item.message .profile .status.away {\n  background: #ffc107;\n}\n\nnav.navbar .dropdown-item.message .profile .status.busy {\n  background: #dc3545;\n}\n\nnav.navbar .dropdown-item.message .profile .status.offline {\n  background: #999;\n}\n\nnav.navbar .dropdown-item.message .content strong {\n  font-size: 1rem;\n}\n\nnav.navbar .dropdown-item.message .content span {\n  font-weight: 300;\n  font-size: 0.85rem;\n}\n\nnav.navbar .dropdown-item.message .content .date {\n  color: #70737a;\n}\n\nnav.navbar .tasks-list strong {\n  font-size: 1rem;\n}\n\nnav.navbar .tasks-list span {\n  font-size: 0.95rem;\n}\n\nnav.navbar .tasks-list .progress {\n  height: 2px;\n  margin-top: 10px;\n  background: #444951;\n}\n\nnav.navbar a.language span {\n  margin-left: 0.2rem;\n  vertical-align: middle;\n}\n\n/* Navbar dropdown effect */\nnav.navbar .dropdown .dropdown-menu {\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\nnav.navbar .dropdown .dropdown-menu.active {\n  -webkit-transform: translateY(0);\n  transform: translateY(0);\n}\n\n/* Navbar Media Query ----------------------------------- */\n@media (max-width: 1331px) {\n  nav.navbar .right-menu {\n    margin-bottom: -3px;\n  }\n\n  nav.navbar .navbar-brand {\n    margin-right: 5px;\n  }\n\n  nav.navbar .search-inner form input {\n    font-size: 1.25rem !important;\n  }\n\n  nav.navbar .search-inner form button.submit {\n    position: absolute;\n    font-size: 2rem;\n    top: 50px;\n    display: block;\n    width: 100%;\n  }\n\n  nav.navbar .brand-text {\n    display: none !important;\n  }\n\n  nav.navbar .brand-text.visible {\n    display: none !important;\n  }\n\n  nav.navbar .brand-text.brand-sm {\n    display: block !important;\n  }\n}\n\n@media (max-width: 991px) {\n  nav.navbar .dropdown-menu {\n    right: -140px;\n  }\n\n  nav.navbar .megamenu {\n    right: 0 !important;\n  }\n\n  nav.navbar a.nav-link {\n    font-size: 0.85rem;\n  }\n\n  nav.navbar .nav-link .badge {\n    width: 16px;\n    height: 16px;\n    line-height: 16px;\n    color: #fff;\n    text-align: center;\n    font-size: 0.6rem;\n  }\n}\n\n@media (max-width: 575px) {\n  nav.navbar .dropdown {\n    position: static;\n  }\n\n  nav.navbar .dropdown-menu {\n    width: 90vw;\n    right: 2.5vw;\n    left: 2.5vw;\n    margin: 0 auto;\n  }\n}\n\n/*************************Side nav*******************************/\n\nnav#sidebar {\n  width: 222px;\n  /* margin-top: 60px; */\n  /* background: #2d3035; */\n  color: #7b7a7a;\n  /* border-right: 1px solid #34373d; */\n  /* shrinked navbar */\n  background-color: #fff;\n  position: relative;\n  padding-bottom: 90px;\n}\n\nnav#sidebar a {\n  color: inherit;\n  text-decoration: none;\n  position: relative;\n}\n\nnav#sidebar a[aria-haspopup=\"menu\"]::after,\nnav#sidebar button[aria-haspopup=\"menu\"]::after {\n  content: \"\\e901\";\n  display: inline-block;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  font-family: \"icomoon\" !important;\n  position: absolute;\n  top: 50%;\n  right: 20px;\n  font-size: 11px;\n}\n\nnav#sidebar a[aria-haspopup=\"menu\"][aria-expanded=\"true\"]::after,\nnav#sidebar button[aria-haspopup=\"menu\"][aria-expanded=\"true\"]::after {\n  -webkit-transform: translateY(-50%) rotate(180deg);\n  transform: translateY(-50%) rotate(180deg);\n}\n\nnav#sidebar.shrinked a[aria-haspopup=\"menu\"]::after {\n  content: \"\\f107\";\n  transform: translate(-50%, -50%);\n  position: absolute;\n  top: 90%;\n  left: 50%;\n}\n\nnav#sidebar.shrinked a[aria-haspopup=\"menu\"][aria-expanded=\"true\"]::after {\n  content: \"\\f106\";\n}\n\nnav#sidebar span.heading {\n  font-weight: 700;\n  margin-left: 20px;\n  color: #494d53;\n  font-size: 1.2rem;\n  margin-bottom: 15px;\n}\n\nnav#sidebar .avatar {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin-right: 15px;\n  background: none;\n  padding: 4px;\n}\n\nnav#sidebar.shrinked .avatar {\n  margin-right: 0px;\n}\n\nnav#sidebar ul {\n  max-height: none;\n  padding-bottom: 0px;\n}\n\nnav#sidebar li {\n  position: relative;\n  margin: 0px;\n}\n\n/* nav#sidebar .sgds.sidenav li.sidenav-item:last-child {\n  position: absolute;\n  bottom: 30px;\n  left: 0;\n  right: 0;\n} */\n\n/* nav#sidebar .sgds.sidenav li.sidenav-item:last-child {\n  position: relative;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: 20px 0 0 0;\n} */\n\nnav#sidebar li a {\n  padding: 12px 12px;\n  display: block;\n  font-size: 15px;\n  font-weight: 400;\n  position: relative;\n  z-index: 1;\n  border: none;\n  color: #7b7a7a;\n  line-height: normal;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n}\n\nnav#sidebar li a .icon,\nnav#sidebar li > .btn.sgds .icon {\n  margin: 0 7px 0 0;\n  font-size: 16px;\n  flex: 0 0 20px;\n}\n\nnav#sidebar li a .icon.icon-user-management,\nnav#sidebar li a .icon.icon-team-management,\nnav#sidebar li a .icon.icon-profile-settings,\nnav#sidebar li a .icon.icon-help,\nnav#sidebar li a .icon.icon-settings {\n  font-size: 17px;\n}\n\nnav#sidebar li a .icon.icon-leaderboard {\n  font-size: 18px;\n}\n\nnav#sidebar li a:hover {\n  color: #09a752;\n}\n\nnav#sidebar li a:focus {\n  box-shadow: none;\n}\n\nnav#sidebar li a[aria-expanded=\"true\"]:before {\n  opacity: 1;\n}\n\nnav#sidebar li.selected .sidenav-collapse li a.active:before,\nnav#sidebar li.selected .sidenav-collapse li a.active:hover:before {\n  background: #10688b;\n  opacity: 1;\n}\n\n#sidebar .sidenav-collapse {\n  margin: 0px;\n}\n\nnav#sidebar li.active > a {\n  background: rgba(3, 189, 90, 0.18);\n  color: #0ca751;\n  font-weight: bold;\n}\n\nnav#sidebar li li.active > a {\n  background: rgb(84, 178, 203);\n}\n\nnav#sidebar li > .btn.sgds {\n  padding: 12px 12px;\n  font-size: 15px;\n  font-weight: 400;\n  position: relative;\n  z-index: 1;\n  border: none;\n  color: #7b7a7a;\n  line-height: normal;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: flex-start;\n}\n\nnav#sidebar li.active > .btn.sgds {\n  background: rgba(3, 189, 90, 0.18);\n  color: #0ca751;\n  font-weight: bold;\n}\n\nnav#sidebar li > .btn.sgds:focus {\n  outline: none;\n  box-shadow: none;\n}\n\nnav#sidebar li.active > .btn.sgds .icon-traininig {\n  font-size: 18px;\n}\n\nnav#sidebar li .sidenav-collapse ul li a {\n  font-size: 14px;\n  padding: 9px 12px 9px 20px;\n}\n\nnav#sidebar.shrinked {\n  width: 80px;\n}\n\nnav#sidebar.shrinked span.heading {\n  margin-left: 0;\n  display: block;\n  text-align: center;\n  font-size: 1rem;\n}\n\nnav#sidebar.shrinked ul {\n  max-height: none;\n}\n\nnav#sidebar.shrinked ul a {\n  padding: 14px 5px;\n  display: block;\n  font-weight: 400;\n  text-align: center;\n  font-size: 0.8rem;\n  word-break: break-word;\n}\n\nnav#sidebar.shrinked ul i {\n  font-size: 1.2rem;\n  text-align: center !important;\n  width: 100%;\n  display: block !important;\n  border: none !important;\n  padding: 0 !important;\n}\n\nnav#sidebar.shrinked ul ul a {\n  padding-left: 10px;\n}\n\nnav#sidebar.shrinked a[data-bs-toggle=\"collapse\"]::after {\n  content: \"\\f107\";\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  position: absolute;\n  top: 88%;\n  left: 50%;\n}\n\nnav#sidebar.shrinked a[aria-expanded=\"true\"]::after {\n  content: \"\\f106\";\n}\n\n/* Sidebar Media Query ----------------------------------- */\n\n@media (min-width: 991px) {\n  nav#sidebar {\n    transition:\n      margin,\n      0.25s ease-out;\n    margin-left: 0px;\n    flex: 0 0 222px;\n  }\n\n  .sideMenuFixed nav#sidebar {\n    margin-left: 0px;\n  }\n\n  nav#sidebar + .page-content {\n    /* width: auto; */\n    flex: auto;\n  }\n\n  nav.navbar .sidebar-toggle {\n    display: none;\n  }\n}\n\n@media (max-width: 991px) {\n  .page-content {\n    width: 100%;\n  }\n\n  .page-content.active {\n    width: calc(100% - 80px);\n  }\n\n  nav#sidebar {\n    /* width: 15%; */\n    margin-left: 0px;\n    flex: 0 0 222px;\n    position: fixed;\n    left: -222px;\n    top: 68.79px;\n    bottom: 0;\n    transition:\n      left,\n      0.25s ease-out;\n    z-index: 99;\n  }\n\n  .sideBarSticky {\n    height: calc(100vh - 73px);\n    overflow-y: auto;\n  }\n\n  .sideMenuFixed nav#sidebar {\n    left: 0;\n  }\n\n  nav#sidebar li a {\n    padding: 16px 18px;\n    font-size: 14px;\n  }\n\n  nav#sidebar li a i,\n  nav#sidebar li button.btn i {\n    margin: -2px 7px 0px 0;\n  }\n\n  nav.navbar .dropdown {\n    border-left: none;\n    margin-left: 8px;\n  }\n\n  nav.navbar .sidebar-toggle {\n    margin: 0 0 0 10px;\n  }\n\n  nav#sidebar span.heading {\n    margin-left: 0;\n    display: block;\n    text-align: center;\n    font-size: 1rem;\n  }\n\n  nav#sidebar ul {\n    max-height: none;\n  }\n\n  /* nav#sidebar ul a {\n    padding: 12px 5px;\n    display: block;\n    font-weight: 400;\n    text-align: center;\n    font-size: 0.8rem;\n  }\n\n  nav#sidebar ul i {\n    font-size: 1.2rem;\n    text-align: center !important;\n    width: 100%;\n    display: block !important;\n    border: none !important;\n    padding: 0 !important;\n  } */\n\n  /* nav#sidebar ul ul a {\n    padding-left: 10px;\n  }\n\n  nav#sidebar.shrinked {\n    margin-left: 0;\n  }\n\n  nav#sidebar a[data-bs-toggle=\"collapse\"]::after {\n    content: \"\\f107\";\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    position: absolute;\n    top: 88%;\n    left: 50%;\n  }\n\n  nav#sidebar a[aria-expanded=\"true\"]::after {\n    content: \"\\f106\";\n  }  */\n}\n\n/***********************dashboard****************************/\n.bredcrumb {\n  padding: 16px 0;\n}\n\n.bredcrumb ul {\n  padding: 0;\n  display: flex;\n  align-items: center;\n  margin: 0px;\n}\n\n.bredcrumb ul li {\n  list-style: none;\n  color: #0ca751;\n  font-size: 14px;\n  padding: 0;\n  position: relative;\n}\n\n.bredcrumb ul li + li {\n  margin: 0 0 0 10px;\n  padding: 0 0 0 12px;\n}\n\n.bredcrumb ul li + li::before {\n  content: \"\\e903\";\n  font-family: \"icomoon\", sans-serif !important;\n  transform: rotate(90deg);\n  position: absolute;\n  left: -3px;\n  color: #0ca751;\n  font-size: 10px;\n  top: 2.2px;\n}\n\n.bredcrumb ul li a {\n  list-style: none;\n  color: #7b7a7a !important;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.loginTrBg {\n  background: #ffc566;\n  position: relative;\n  padding: 120px 0px;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.loginTrBg::before {\n  content: \"\";\n  position: absolute;\n  left: -5%;\n  right: -5%;\n  top: -30%;\n  bottom: 50%;\n  background: #fff;\n  transform: rotate(-5deg);\n}\n\n.loginTrBg .loginTrBgIn {\n  max-width: 430px;\n  flex: 0 0 460px;\n  position: relative;\n  z-index: 1;\n}\n\n.loginTrBg .loginTrBgIn .card {\n  background: #fff;\n  box-shadow: 0px 3px 6px 2px rgba(0, 0, 0, 0.16);\n  border-radius: 0;\n  margin: 0;\n}\n\n.loginTrBg .loginTrBgIn .card .card-body {\n  padding: 40px;\n}\n\n.loginTitleWrap {\n  margin: 0 0 24px 0;\n}\n\n.loginTitleWrap h5 {\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0 0 0px 0;\n  color: #000;\n}\n\n.loginTitleWrap p {\n  font-size: 14px;\n  font-weight: 400;\n  margin: 6px 0 0px 0;\n  color: rgba(114, 114, 114, 0.9);\n  line-height: 19.5px;\n}\n\n.loginTrBg .loginTrBgIn .form-group {\n  margin: 0 0 24px 0;\n}\n\n.loginTrBg .loginTrBgIn .form-group label {\n  font-size: 14px;\n  font-weight: 500;\n  margin: 0 0 4px 0;\n}\n\n.loginTrBg .loginTrBgIn .form-group .form-control {\n  font-size: 17px;\n  font-weight: 400;\n  color: #000;\n  padding: 0 16px 0 16px;\n  text-shadow: none;\n  height: 51px;\n  border: 0.5px solid rgba(192, 192, 192, 0.4);\n  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.16);\n  border-radius: 4px;\n  background: #fff;\n}\n\n.btn {\n  border-radius: 5px;\n  padding: 11px 18px;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.btn.btn-sm {\n  border-radius: 4px;\n  padding: 9px 18px;\n  font-size: 15px;\n}\n\n.loginTrBg .loginTrBgIn .btn {\n  padding: 14px 18px;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.mapFiltersBar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #fff;\n  padding: 16px 24px;\n  border-radius: 4px;\n  gap: 14px;\n}\n\n.mapFiltersBar h5 {\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.mapFiltersBar h5 {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.mapFiltersBar select {\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  height: 40px;\n}\n\n.whiteContBar {\n  background: #fff;\n  border-radius: 5px;\n  padding: 18px 30px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.card.hptCard .card-header {\n  padding: 22px 30px;\n}\n\n.card.hptCard .card-footer {\n  padding: 22px 30px;\n}\n\n.card.hptCard .card-body {\n  padding: 22px 30px;\n}\n\n.cardTitle h5 {\n  font-size: 18px;\n  font-weight: 700;\n  color: #000;\n  margin: 0 0 3px 0;\n  line-height: 1.1;\n}\n\n.cardTitle p {\n  font-size: 16px;\n  font-weight: 400;\n  color: #343434;\n  margin: 0 0 0px 0;\n  line-height: 1.5;\n}\n\n.card .card-header {\n  background: transparent;\n}\n\n.filterList {\n  background: #f2f4fb;\n  padding: 14px 24px;\n  border: 1px solid #dfe2ec;\n  position: relative;\n  cursor: pointer;\n  height: 100%;\n  min-height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.filterList:hover {\n  background: #dce1f2;\n}\n\n.filterList .card-title {\n  margin: 0px;\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.filterList .card-text {\n  margin: 0px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #7b7979;\n}\n\n.filterList.bg-success {\n  border-color: #198754;\n}\n\n.filterList.bg-success .card-text {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n/* .card.hptCard.mt-4 {\n    min-height: calc(100% - 1.5rem);\n  } */\n\n.card .table td,\n.card .table th {\n  padding-left: 15px;\n  padding-right: 15px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n\n.card .table td:first-child,\n.card .table th:first-child {\n  padding-left: 28px;\n}\n\n.table .thead-light th {\n  background-color: #e4e6ed;\n  color: #343434;\n  font-size: 15px;\n  text-transform: none;\n  font-weight: 400;\n}\n\n.table-bordered > :not(caption) > * {\n  border-color: #dcdcdc;\n}\n\n.table td {\n  color: #343434;\n  font-size: 15px;\n  text-transform: none;\n  font-weight: 400;\n  border-color: #dcdcdc;\n}\n\n.table td.table-secondary {\n  background: #eeeeee;\n  text-align: center;\n  vertical-align: middle;\n  font-size: 14px;\n  border-color: #dcdcdc;\n}\n\n.table td input {\n  color: #000000;\n  padding: 0 16px;\n  font-size: 14px;\n  width: 100%;\n  height: 42px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0;\n  box-shadow: inset 0 0px 6px rgba(0, 0, 0, 0.14);\n}\n\n.headnumText {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.headnumText .cardDropDown {\n  display: flex;\n  align-items: center;\n}\n\n.pageTitle {\n  padding: 24px 0 12px;\n  font-size: 16px;\n  font-weight: 400;\n  color: #000;\n}\n\n.pageTitleWrap {\n  padding: 24px 0 12px;\n}\n\n.pageTitleWrap h5 {\n  font-size: 18px;\n  font-weight: 500;\n  color: #000;\n  margin: 0 0 5px 0;\n  line-height: 1.2;\n}\n\n.pageTitleWrap p {\n  font-size: 15px;\n  color: rgba(0, 0, 0, 0.6);\n  line-height: 1.2;\n  margin: 0px;\n  font-weight: 400;\n}\n\n.bg-theme-light {\n  position: relative;\n  /* background: #f2f4fb; */\n  z-index: 1;\n  min-height: calc(100vh - 106px);\n}\n\n.bg-theme-light::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  background: #fae466;\n  height: 100%;\n  z-index: -1;\n}\n\n.loginTrBg.afterLogin {\n  background: #ffecce;\n}\n\n.loginTrBg.afterLogin:before {\n  display: none;\n}\n\n.form-navigate-block {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #dee2e6;\n  margin: 0 -1rem;\n  padding: 4px 20px 14px;\n}\n\n.form-navigate-block .pageName {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n}\n\n.form-navigate-block .pageName .number {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  background: rgba(38, 81, 202, 0.1);\n  margin: 0 10px 0 0;\n  border-radius: 100px;\n  font-weight: 600;\n  font-size: 18px;\n  color: #2651ca;\n}\n\n.form-navigate-block .pageName.pending .number {\n  background: none;\n  width: auto;\n  height: auto;\n  font-size: 14px;\n  color: #665f53;\n}\n\n.form-navigate-block .pageName.pending {\n  font-size: 15px;\n  color: #665f53;\n}\n\n.form-navigator-body {\n  padding: 24px 10px;\n}\n\n.form-navigate-footer {\n  border-top: 1px solid #dee2e6;\n  margin: 0 -1rem;\n  padding: 16px 20px 14px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 14px;\n}\n\n.form-navigate-footer .btn.btn-outline-secondary {\n  border: 1px solid #000000;\n  color: #000000;\n  opacity: 1;\n  padding: 7px 20px;\n}\n\n.form-navigate-footer .btn.btn-outline-secondary:hover {\n  background: #dee3f0;\n  color: #45474c;\n  border-color: #d0d5e2;\n}\n\n.form-navigate-footer .btn {\n  padding: 8px 20px;\n  min-width: 100px;\n  border-radius: 4px;\n}\n\n.form-group {\n  margin: 0 0 20px;\n}\n.form-group label {\n  font-size: 14px;\n  color: #000000;\n  margin: 0 0 4px 0;\n  display: block;\n}\n\n.form-group input {\n  font-size: 14px;\n  color: #000000;\n  padding: 0 16px;\n  width: 100%;\n  height: 48px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n\n  box-shadow: inset 0 0px 6px rgba(0, 0, 0, 0.14);\n}\n\n.custom-select select {\n  font-size: 14px;\n  color: #000000;\n  padding: 0 16px;\n  width: 100%;\n  height: 48px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  background-color: #fff;\n  background-image: url(data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2012%2012%22%3E%3Ctitle%3Edown-arrow%3C%2Ftitle%3E%3Cg%20fill%3D%22%23000000%22%3E%3Cpath%20d%3D%22M10.293%2C3.293%2C6%2C7.586%2C1.707%2C3.293A1%2C1%2C0%2C0%2C0%2C.293%2C4.707l5%2C5a1%2C1%2C0%2C0%2C0%2C1.414%2C0l5-5a1%2C1%2C0%2C1%2C0-1.414-1.414Z%22%20fill%3D%22%23000000%22%3E%3C%2Fpath%3E%3C%2Fg%3E%3C%2Fsvg%3E);\n  background-size: 0.7em;\n  background-position: calc(100% - 1.3em) center;\n  background-repeat: no-repeat;\n  border-radius: 4px;\n  box-shadow: none;\n  outline: none;\n  box-shadow: inset 0 0px 6px rgba(0, 0, 0, 0.14);\n}\n\n.custom-select select:focus,\n.custom-select select:active {\n  box-shadow: none;\n}\n\n.referenceText {\n  font-size: 13px;\n  font-style: italic;\n  font-weight: 600;\n}\n\n.secTitle h5 {\n  font-size: 15px;\n  font-weight: 600;\n  margin: 8px 0 14px 0;\n}\n\n.custom-radio.form-check {\n  position: relative;\n  margin: 0px;\n  padding: 0px;\n}\n\nbody .custom-radio .form-check-input {\n  margin: 0px;\n  cursor: pointer;\n  accent-color: #ffecce;\n  position: absolute;\n  left: 0;\n  top: 2px;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n}\n\n.custom-radio .form-check-label {\n  margin: 0;\n  cursor: pointer;\n  font-size: 15px;\n  padding: 0 0 0 28px;\n  margin: 0px;\n}\n\n.custom-radio .form-check-label:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 2px;\n  width: 20px;\n  height: 20px;\n  border-radius: 100px;\n  border: 1px solid #ccc;\n}\n\n.custom-radio .form-check-label:after {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  top: 6px;\n  width: 12px;\n  height: 12px;\n  border-radius: 100px;\n  background: #2651d6;\n  transform: scale(0);\n  transition: 0.25s ease-out;\n}\n\n.custom-radio .form-check-input:checked + .form-check-label:after {\n  transform: scale(1);\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.back-nav {\n  background: inherit;\n  border: none;\n  color: black !important;\n  text-decoration: none;\n}\n\n.export-col {\n  flex: 0 0 20% !important;\n  max-width: 20% !important;\n  padding-left: 4px !important;\n  padding-right: 4px !important;\n}\n\n.export-col .form-select {\n  width: 100% !important;\n  min-width: 0 !important;\n}\n\n.export-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(255, 255, 255, 0.8);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\ntable,\nth,\ntd {\n  border: 1px solid black !important;\n  border-collapse: collapse;\n}\ntd:not(:first-child),\nth:not(:first-child) {\n  text-align: center;\n}\n\ntable {\n  width: 100%;\n  table-layout: fixed;\n}\n\ntable th,\ntable td {\n  white-space: normal; /* ✅ allow wrapping */\n  word-wrap: break-word; /* ✅ break long words */\n  overflow: visible; /* ✅ no clipping */\n}\n\n.table-scroll {\n  overflow-x: auto;\n}\n\n.table-scroll table {\n  border-collapse: collapse;\n  table-layout: auto; /* IMPORTANT: remove fixed */\n  width: max-content; /* allow natural expansion */\n}\n\n.table-scroll th,\n.table-scroll td {\n  max-width: 120px;\n  min-width: 120px; /* uniform readable width */\n  padding: 8px;\n  text-align: center;\n  white-space: normal; /* allow wrapping */\n  word-break: break-word;\n}\n\n/* Apply alternating color to every pair */\n/* Skip column 1 (Place) and 2 (TOTAL VISITS if single) */\n/* Pair 1 */\n.table-scroll th:nth-child(3),\n.table-scroll td:nth-child(3) {\n  background-color: #cfeeff; /* slightly darker */\n}\n.table-scroll th:nth-child(4),\n.table-scroll td:nth-child(4) {\n  background-color: #d9f2ff;\n}\n\n/* Pair 2 */\n.table-scroll th:nth-child(5),\n.table-scroll td:nth-child(5) {\n  background-color: #d2efd2;\n}\n.table-scroll th:nth-child(6),\n.table-scroll td:nth-child(6) {\n  background-color: #dff5df;\n}\n\n/* Pair 3 */\n.table-scroll th:nth-child(7),\n.table-scroll td:nth-child(7) {\n  background-color: #ffefb3;\n}\n.table-scroll th:nth-child(8),\n.table-scroll td:nth-child(8) {\n  background-color: #fff4cc;\n}\n\n/* Pair 4 */\n.table-scroll th:nth-child(9),\n.table-scroll td:nth-child(9) {\n  background-color: #d9d2ff;\n}\n.table-scroll th:nth-child(10),\n.table-scroll td:nth-child(10) {\n  background-color: #e6e0ff;\n}\n\n/* Pair 5 */\n.table-scroll th:nth-child(11),\n.table-scroll td:nth-child(11) {\n  background-color: #ffd9e6;\n}\n.table-scroll th:nth-child(12),\n.table-scroll td:nth-child(12) {\n  background-color: #ffe6f0;\n}\n\n/* Pair 6 */\n.table-scroll th:nth-child(13),\n.table-scroll td:nth-child(13) {\n  background-color: #ccf2f5;\n}\n.table-scroll th:nth-child(14),\n.table-scroll td:nth-child(14) {\n  background-color: #e0f7fa;\n}\n\n/* Pair 7 */\n.table-scroll th:nth-child(15),\n.table-scroll td:nth-child(15) {\n  background-color: #e6f2d9;\n}\n.table-scroll th:nth-child(16),\n.table-scroll td:nth-child(16) {\n  background-color: #f1f8e9;\n}\n\n/* Pair 8 */\n.table-scroll th:nth-child(17),\n.table-scroll td:nth-child(17) {\n  background-color: #ffe0eb;\n}\n.table-scroll th:nth-child(18),\n.table-scroll td:nth-child(18) {\n  background-color: #fff0f5;\n}\n\n/* Pair 9 */\n.table-scroll th:nth-child(19),\n.table-scroll td:nth-child(19) {\n  background-color: #d9f0da;\n}\n.table-scroll th:nth-child(20),\n.table-scroll td:nth-child(20) {\n  background-color: #e8f5e9;\n}\n\n/* Pair 10 */\n.table-scroll th:nth-child(21),\n.table-scroll td:nth-child(21) {\n  background-color: #e0d9f2;\n}\n.table-scroll th:nth-child(22),\n.table-scroll td:nth-child(22) {\n  background-color: #ede7f6;\n}\n\n/* Pair 11 */\n.table-scroll th:nth-child(23),\n.table-scroll td:nth-child(23) {\n  background-color: #f9d6e2;\n}\n.table-scroll th:nth-child(24),\n.table-scroll td:nth-child(24) {\n  background-color: #fce4ec;\n}\n\n/* Pair 12 */\n.table-scroll th:nth-child(25),\n.table-scroll td:nth-child(25) {\n  background-color: #d6e9fc;\n}\n.table-scroll th:nth-child(26),\n.table-scroll td:nth-child(26) {\n  background-color: #e3f2fd;\n}\n\n/* Container spacing */\n.custom-tabs {\n  border-bottom: 1px solid #e5e7eb;\n}\n\n/* Default tab */\n.custom-tabs .nav-link {\n  border: none;\n  color: #010205;\n  font-weight: 500;\n  padding: 10px 16px;\n  position: relative;\n  transition: all 0.1s ease;\n}\n\n/* Hover effect */\n.custom-tabs .nav-link:hover {\n  color: #0d6efd;\n  background: transparent;\n}\n\n/* Active tab */\n.custom-tabs .nav-link.active {\n  color: #0d6efd;\n  font-weight: 600;\n  background: transparent;\n}\n\n/* Animated underline */\n.custom-tabs .nav-link::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: -1px;\n  width: 0%;\n  height: 3px;\n  background-color: rgb(250 228 102);\n  transition: width 0.1s ease;\n}\n.custom-tabs .nav-link.active::after {\n  width: 100%;\n}\n\n/* Wrapper for spacing */\n.custom-tabs-wrapper {\n  background: #f8f9fb;\n  padding: 8px 12px;\n  border-radius: 10px;\n}\n\n/* Tabs container */\n.custom-tabs {\n  border-bottom: none !important;\n  gap: 6px;\n}\n\n/* Default tab */\n.custom-tabs .nav-link {\n  border: none !important;\n  border-radius: 8px;\n  padding: 8px 16px;\n  color: #2d2d2d;\n  font-weight: 500;\n  transition: all 0.1s ease;\n  position: relative;\n}\n\n/* Hover */\n.custom-tabs .nav-link:hover {\n  background-color: #eef2ff;\n  color: #0d6efd;\n}\n\n/* Active tab */\n.custom-tabs .nav-link.active {\n  background: #ffffff;\n  color: #0d6efd;\n  font-weight: 600;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);\n}\n\n/* Bottom accent line */\n.custom-tabs .nav-link.active::after {\n  content: \"\";\n  position: absolute;\n  bottom: -6px;\n  left: 20%;\n  width: 60%;\n  height: 3px;\n  background: #fae466; /* yellow accent like your UI */\n  border-radius: 10px;\n}\n\n/* Prevent text wrapping */\n.custom-tabs .nav-link {\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
